<footer class="app-footer">
  <p>Copyright Megayuntas S.A.C. &copy; 2025 All Rigths Reserved</p>
</footer>